import { render, staticRenderFns } from "./AdminGeneralSettings.vue?vue&type=template&id=b7a6854e&scoped=true"
import script from "./AdminGeneralSettings.vue?vue&type=script&lang=ts"
export * from "./AdminGeneralSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a6854e",
  null
  
)

export default component.exports